import { makeRequest } from '../../../lib/api';
import {
  SubscriptionsInterface,
} from '../api/socket.types';

const SUBSCRIPTIONS_PATH = '/v1/subscriptions';

const socketController = {

  createOrderPaymentSubscription: (request: SubscriptionsInterface): Promise<any> => {
    return makeRequest('post', SUBSCRIPTIONS_PATH, request);
  },

  deleteOrderPaymentSubscription: (subscriptionId: string): Promise<any> => {
    return makeRequest('delete', `${ SUBSCRIPTIONS_PATH }/${ subscriptionId }`);
  },

};

export { socketController };
